var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.getClassName("cart-item") }, [
    _c("div", { class: _vm.getClassName("cart-item__counter") }, [
      _vm._v(_vm._s(_vm.index + 1))
    ]),
    _vm._v(" "),
    _c(
      "a",
      {
        attrs: {
          href:
            "/items/" + _vm.value.item.category.slug + "/" + _vm.value.item.id
        }
      },
      [
        _c("v-img", {
          class: _vm.getClassName("cart-item__thumbnail"),
          attrs: {
            src: _vm.value.color.recommend_thumbnail,
            contain: "",
            width: _vm.media ? "80" : "140",
            height: _vm.media ? "80" : "140"
          },
          scopedSlots: _vm._u([
            {
              key: "placeholder",
              fn: function() {
                return [_c("ImagePlaceholder")]
              },
              proxy: true
            }
          ])
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { class: _vm.getClassName("cart-item__content") }, [
      _c("div", [
        _vm.value.item.category
          ? _c("div", { class: _vm.getClassName("cart-item__option") }, [
              _vm._v(
                "\n        " + _vm._s(_vm.value.item.category.name) + "\n      "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("h2", { class: _vm.getClassName("cart-item__name") }, [
          _c(
            "a",
            {
              attrs: {
                href:
                  "/items/" +
                  _vm.value.item.category.slug +
                  "/" +
                  _vm.value.item.id
              }
            },
            [
              _vm._v(
                "\n          " + _vm._s(_vm.value.item.name) + "\n        "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _vm.value.item.colors.length > 1
          ? _c("div", { class: _vm.getClassName("cart-item__option") }, [
              _vm._v(
                "\n        カラー：" + _vm._s(_vm.value.color.name) + "\n      "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.value.item.sizes.length > 1
          ? _c("div", { class: _vm.getClassName("cart-item__option") }, [
              _vm._v(
                "\n        サイズ：" + _vm._s(_vm.value.size.name) + "\n      "
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { class: _vm.getClassName("cart-item__value") }, [
        _c("div", { class: _vm.getClassName("cart-item__price") }, [
          _c("span", { class: _vm.getClassName("cart-item__number") }, [
            _vm._v(_vm._s(_vm.getNumberFormat(_vm.value.price)))
          ]),
          _vm._v("\n        円(税込)\n      ")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.getClassName("cart-item__quantity") },
          [
            _c("v-text-field", {
              class: _vm.getClassName("cart-item__field"),
              attrs: {
                type: "number",
                min: "1",
                outlined: "",
                "hide-details": "",
                dense: ""
              },
              model: {
                value: _vm.internalValue,
                callback: function($$v) {
                  _vm.internalValue = $$v
                },
                expression: "internalValue"
              }
            }),
            _vm._v(" "),
            _c("span", { class: _vm.getClassName("cart-item__unit") }, [
              _vm._v(_vm._s(_vm.value.item.unit))
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          class: _vm.getClassName("cart-item__remove"),
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.destroy()
            }
          }
        },
        [_vm._v("削除")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }